module.exports = __webpack_public_path__ + "static/media/walnut.3e626430.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/interiorColors/walnut.jpg
// module id = 40
// module chunks = 0